import { useCallback, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import searchImage from '../assets/search.svg';
import { searchByText } from '../redux/filters/actions';

const Search = () => {
  const [searchText, setsearchText] = useState('');
  const dispatch = useDispatch();

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 1000);

    };
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setsearchText(value);
  };



  const inputHandler = useCallback(debounce(handleChange), []);
  useEffect(() => {    
    dispatch(searchByText(searchText));
  });


  return (
    <div
      className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200"
    >
      <input
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
        onChange={inputHandler}
      />
      <img
        className="inline h-6 cursor-pointer"
        src={searchImage}
        alt="Search"
      />
    </div>
  );
}

export default Search;